import { createFileRoute, redirect } from '@tanstack/react-router';

// RELEASE-ONLY-PAYMENTS-OFF
// Platby se v tomhle releasu nedodávají, ale v1.0.2 a v1.0.3 na tuhle adresu
// vedly ze sidebaru, takže ji uživatelé mohou mít v záložkách. Místo holého
// „Not Found" je pošleme na dashboard — i z detailu platby (splat v payments/$).
export const Route = createFileRoute('/$locale/smartbanking/payments')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$locale/smartbanking/dashboard',
      params: { locale: params.locale },
      replace: true,
    });
  },
});
